import React, { Component } from "react";

import Modal from "react-bootstrap/Modal";

import Backend from "../../../utils/Backend";
import General from "../../../utils/General";
import Notify from "../../../utils/Notify";

import ImageUpload from "../common/ImageUpload";

export default class VendorDetailsModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      ...this._getState(props),
      show: props.show,
      isLoading: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState(this._getState(nextProps));
  }

  _getState(props) {
    return {
      ...props,
      data: General.clone(props.data),
    };
  }

  _handleChange(e) {
    const { data } = this.state;

    let value = e.target.value;

    data[e.target.name] = value;

    this.setState({ data });
  }

  _isFormValid() {
    const { data } = this.state;

    const { logo, title, eircode } = data;

    let error = null;

    if (!logo) {
      error = "Please upload a valid logo.";
    } else if (!title) {
      error = "Please enter a valid company name.";
    } else if (!eircode) {
      error = "Please enter a valid eircode.";
    }

    if (error) {
      Notify.error(error);
      return false;
    }

    return true;
  }

  _updateVendor() {
    let { data } = this.state;

    if (!this._isFormValid()) {
      return;
    }

    data = {
      id: data.id,
      title: data.title,
      logo: data.logo.id,
      eircode: data.eircode,
    };

    this.setState({ isLoading: true });

    Backend.updateVendor(data)
      .then((data) => {
        this.setState({ data, isLoading: false });
        Notify.success("Vendor has been updated successfully.");
        this.props.onUpdated();
      })
      .catch((error) => {
        Notify.error(error.message);
        this.setState({ isLoading: false });
      });
  }

  render() {
    let { show, data, isLoading } = this.state;

    if (!data) {
      return null;
    }

    return (
      <Modal
        show={show}
        onHide={() => {
          if (!isLoading) {
            this.props.onHide();
          }
        }}
      >
        <div className="modal-content">
          <Modal.Header closeButton>
            <Modal.Title>Edit</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <form>
              <div className="form-group">
                <label>Company Photo</label>
                <span className="text-danger">*</span>
                <ImageUpload
                  image={data?.logo}
                  hidePreview={false}
                  cropImage={true}
                  aspectRatio={1 / 1}
                  onUpdated={(logo) => {
                    data.logo = logo;

                    this.setState({ data });
                  }}
                />
              </div>
              <div className="form-group">
                <label>
                  Company Name
                  <span className="text-danger">*</span>
                </label>
                <div className="row">
                  <div className="col-lg-12">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Name"
                      name="title"
                      value={data?.title}
                      onChange={(e) => this._handleChange(e)}
                    />
                  </div>
                </div>
              </div>

              <div className="form-group">
                <label>Company Eircode</label>
                <span className="text-danger">*</span>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Eircode"
                  name="eircode"
                  value={data?.eircode}
                  onChange={(e) => this._handleChange(e)}
                />
              </div>
            </form>
          </Modal.Body>

          <Modal.Footer>
            <button
              type="button"
              className="btn btn-outline-primary font-weight-bold"
              onClick={() => this.props.onHide()}
            >
              Close
            </button>

            <button
              type="button"
              className="btn btn-primary font-weight-bold"
              disabled={isLoading}
              onClick={() => this._updateVendor()}
            >
              Save Changes
            </button>
          </Modal.Footer>
        </div>
      </Modal>
    );
  }
}
